<template>
    <div v-if="mostrarMenu" class="mt-2">
        <h4 class="heading-1">
            <span>SGTEC</span>
        </h4>
        <b-list-group>
            <relacao-etapas></relacao-etapas>
            <relacao-etapas-gestores></relacao-etapas-gestores>
            <relacao-etapas-gerentes></relacao-etapas-gerentes>
            <relacao-etapas-apoios></relacao-etapas-apoios>
            <relacao-etapas-cancelamento></relacao-etapas-cancelamento>
            <relatorio-faturamento-etapas></relatorio-faturamento-etapas>
        </b-list-group>
    </div>
</template>

<script>
import RelacaoEtapas from '../uabs/relatorios/RelacaoEtapas'
import RelacaoEtapasCancelamento from '../uabs/relatorios/RelacaoEtapasCancelamento'
import RelacaoEtapasGestores from '../gestores/relatorios/RelacaoEtapas'
import RelacaoEtapasGerentes from '../gerentes/relatorios/RelacaoEtapas'
import RelacaoEtapasApoios from '../apoios/relatorios/RelacaoEtapas'
import RelatorioFaturamentoEtapas from './faturamento/RelatorioFaturamentoEtapas'

export default {
    components: {
        RelacaoEtapas,
        RelacaoEtapasGestores,
        RelacaoEtapasGerentes,
        RelacaoEtapasApoios,
        RelacaoEtapasCancelamento,
        RelatorioFaturamentoEtapas
    },

    computed: {
        mostrarMenu() {
            return this.$temAcessoView('SGTEC-REL-00')
        }
    }
}
</script>
